import { type TransactionSummaryDTO } from '@capsicum/common';

export const formatTransactionSum = (transactions: Array<TransactionSummaryDTO>): string => {
	// When working on this formatting, remember that dailySum may be -0 and
	// -0 compares equal to 0 in JavaScript, but String(-0) is still '-0'
	// which we don't want to present to the user

	const dailySum = transactions.reduce((sum, tx) => {
		// Default to 0 if the amount is missing
		const amount = parseFloat(tx.amount ?? '0');

		return tx.isNegativeBalance ? sum - amount : sum + amount;
	}, 0);
	let sign = '-';

	if (dailySum > 0) {
		sign = '+';
	} else if (dailySum === 0) {
		sign = '±';
	}

	const decimals = Number.isInteger(dailySum) ? 0 : 2;

	return `${sign}${Math.abs(dailySum).toFixed(decimals)}`;
};
